<template>
  <v-slide-y-reverse-transition>
    <v-container v-if="pivotItem" class="px-2 py-3" fluid>
      <v-similar-items-filters-title />
      <v-similar-items-filters-like-pattern-brand />
      <v-similar-items-filters-like-pattern-name />
      <v-similar-items-filters-max-price />
      <v-similar-items-filters-min-price />
      <v-similar-items-filters-apply-button />
    </v-container>
  </v-slide-y-reverse-transition>
</template>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapGetters, mapMutations } = createNamespacedHelpers("matching");

import VSimilarItemsFiltersTitle from "./SimilarItemsFiltersTitle";
import VSimilarItemsFiltersLikePatternBrand from "./SimilarItemsFiltersLikePatternBrand";
import VSimilarItemsFiltersLikePatternName from "./SimilarItemsFiltersLikePatternName";
import VSimilarItemsFiltersMaxPrice from "./SimilarItemsFiltersMaxPrice";
import VSimilarItemsFiltersMinPrice from "./SimilarItemsFiltersMinPrice";
import VSimilarItemsFiltersApplyButton from "./SimilarItemsFiltersApplyButton";

export default {
  components: {
    VSimilarItemsFiltersTitle,
    VSimilarItemsFiltersLikePatternBrand,
    VSimilarItemsFiltersLikePatternName,
    VSimilarItemsFiltersMaxPrice,
    VSimilarItemsFiltersMinPrice,
    VSimilarItemsFiltersApplyButton
  },
  computed: {
    ...mapGetters(["pivotItem"])
  },
  methods: {
    ...mapMutations(["clearSimilarItemsFilters"])
  },
  beforeDestroy() {
    this.clearSimilarItemsFilters();
  }
};
</script>
